import { render } from "./ActivityTracking.vue?vue&type=template&id=512263a9&scoped=true"
import script from "./ActivityTracking.vue?vue&type=script&lang=js"
export * from "./ActivityTracking.vue?vue&type=script&lang=js"

import "./ActivityTracking.vue?vue&type=style&index=0&id=512263a9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512263a9"]])

export default __exports__